import React from 'react';
import { Tab } from 'semantic-ui-react';
import { SignInTabPane, SignUpTabPane } from './TabPanes';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const AuthTab = (props) => {
  const panes = [
    {
      menuItem: props.t('public:auth.sign_in'),
      render: () => <SignInTabPane
                      onSubmit={props.onSignIn}
                      onForgotPassword={props.onForgotPassword}
                      error={props.error}
                      showConfirmationCode={props.showConfirmationCode} />
    },
    {
      menuItem: props.t('public:auth.create_account'),
      render: () => <SignUpTabPane
                      onSubmit={props.onSignUp}
                      error={props.error}
                      success={props.success} />
    }
  ];

  // TODO: this index is an ungly hardcoded hack!
  return <Tab
           activeIndex={props.location.pathname === '/signup' ? 1 : 0}
           panes={panes}
           onTabChange={props.onTabChange}/>;
};

export default withNamespaces('public')(withRouter(AuthTab));



// WEBPACK FOOTER //
// ./src/public/components/Auth/AuthTab.js